import type { Casework } from "building-types/casework/caseworkTypes";
import type { LegacyRoomLayoutElectrical } from "building-types/electrical/electricalLegacyRoomLayoutTypes";
import type { FloorAssembly } from "building-types/floors/floorAssemblyTypes";
import type { PlanarGraphPerimeterInfo } from "building-types/planarGraphs/planarGraphPerimeterInfo";
import type { Prop, PropAttributeTable } from "building-types/props/propTypes";
import type { Room } from "building-types/rooms/roomTypes";
import type { RoomType } from "building-types/rooms/roomTypesEnum";
import type { WallIndex } from "building-types/walls/wallIndex";
import type { WindowDescriptor } from "building-types/windows/windowTypes";
import type { Table } from "common/data/table";

export type RoomLayoutReturnValue = Partial<{
  props: Prop[];
  casework: Casework[];
  electricLayouts?: LegacyRoomLayoutElectrical;
}>;

export type MaybeAsyncRoomLayoutReturnValue = RoomLayoutReturnValue | null | Promise<RoomLayoutReturnValue | null>;

export type RoomLayoutFunc = (props: {
  room: Room;
  floor: FloorAssembly;
  palette: PropAttributeTable;
  wallIndex: WallIndex;
  planarGraphPerimeter: PlanarGraphPerimeterInfo;
  windowCatalog: Table<WindowDescriptor>;
}) => MaybeAsyncRoomLayoutReturnValue;

export interface RoomLayoutGenerator {
  roomType: RoomType;
  generate: RoomLayoutFunc;
}

export function hashRoomLayoutGenerators(...roomLayouts: RoomLayoutGenerator[]): {
  [layoutHash: string]: RoomLayoutGenerator;
} {
  const hashedRoomLayouts: { [layoutHash: string]: RoomLayoutGenerator } = {};

  for (const roomLayout of roomLayouts) {
    const { roomType } = roomLayout;
    hashedRoomLayouts[roomType] = roomLayout;
  }

  return hashedRoomLayouts;
}

export function overloadIndex(index: number, size: number = 4): number {
  return (index + size) % size;
}
